import type { FunnelRow } from "./types";

export function total(rows: FunnelRow[], key: keyof FunnelRow): number {
  return rows.reduce((sum, row) => sum + Number(row[key] ?? 0), 0);
}

export function percent(numerator: number, denominator: number): string {
  return denominator > 0 ? `${((numerator / denominator) * 100).toFixed(1)}%` : "—";
}
